import React from 'react';
import PropTypes from 'prop-types';
import { ItemLabelWraper, ItemValueWrapper } from '../styled';
import RiskRating from '../RiskRating';

const AlertRiskRating = ({ itemLabel, itemValue }) => (
  <>
    <ItemLabelWraper span="12">{itemLabel}</ItemLabelWraper>
    <ItemValueWrapper span="12">
      {itemValue ? <RiskRating value={itemValue} highlighter /> : '-'}
    </ItemValueWrapper>
  </>
);

AlertRiskRating.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  itemValue: PropTypes.string
};

export default AlertRiskRating;
